/**
 * TargetAudience entity model class
 *
 * This file is part of Minasa
 * (c) Kaden und Partner AG
 */
import BaseModel from './BaseModel';
import BaseCollection from './BaseCollection';
import dayjs from 'dayjs';

export class TargetAudience extends BaseModel {
    defaults() {
        return {
            // entity properties
            id: null,
            bezeichnung: null,
            display_order: null,
            creator_id: null,
            created: null,
            modifier_id: null,
            modified: null,
            interface_value_ident: null,

            // view fields
            creator: null,
            creator_firstname: null,
            creator_lastname: null,
            modifier: null,
            modifier_firstname: null,
            modifier_lastname: null,
        };
    }

    mutations() {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null),
            creator_id: Number,
            created: dayjs,
            modifier_id: Number,
            modified: dayjs,
        };
    }

    entityName() {
        return 'TargetAudience';
    }
}

export class TargetAudienceCollection extends BaseCollection {
    options() {
        return {
            model: TargetAudience,
        };
    }

    entityName() {
        return 'TargetAudience';
    }
}
